<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
<!--        <sidebar-link-->
<!--          :name="$t('sidebar.dashboard')"-->
<!--          to="/dashboard"-->
<!--          icon="tim-icons icon-chart-pie-36"/>-->
        <sidebar-link
          :name="$t('sidebar.userProfile')"
          to="/profile"
          icon="tim-icons icon-single-02"/>
        <sidebar-link
            :name="$t('sidebar.users')"
            to="/users"
            icon="tim-icons icon-single-02"/>
        <sidebar-link
            :name="$t('sidebar.products')"
            to="/products"
            icon="tim-icons icon-single-02"/>
        <sidebar-link
          :name="$t('sidebar.logs')"
          to="/logs"
          icon="tim-icons icon-single-02"/>
<!--        <sidebar-link-->
<!--          v-show="false"-->
<!--          :name="$t('sidebar.notifications')"-->
<!--          to="/notifications"-->
<!--          icon="tim-icons icon-bell-55"/>-->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar/>

      <dashboard-content @click.native="toggleSidebar"/>

      <content-footer/>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu'
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}
</script>
